import PropTypes from "prop-types";
import React from "react";
import { Container, Card, CardBody, Row, Col, Button } from "reactstrap";

// PrimeReact
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";

// Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// i18n
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const AdminBilling = props => {
  document.title = "Admin | Billing Management";

  // ================= OVERVIEW =================
  const overview = {
    totalRevenue: 15420,
    activeSubscriptions: 42,
    unpaidInvoices: 6,
    totalClients: 58,
  };

  // ================= SUBSCRIPTIONS =================
  const subscriptions = [
    {
      id: 1,
      client: "ABC Realty",
      plan: "Annual",
      amount: 999,
      startDate: "01 Jan 2025",
      endDate: "31 Dec 2025",
      status: "Active",
    },
    {
      id: 2,
      client: "Prime Homes",
      plan: "Monthly",
      amount: 99,
      startDate: "01 Feb 2025",
      endDate: "01 Mar 2025",
      status: "Expired",
    },
  ];

  // ================= INVOICES =================
  const invoices = [
    {
      id: 1,
      invoiceNo: "INV-1001",
      client: "ABC Realty",
      date: "10 Jan 2025",
      amount: 999,
      status: "Paid",
    },
    {
      id: 2,
      invoiceNo: "INV-1002",
      client: "Prime Homes",
      date: "10 Feb 2025",
      amount: 99,
      status: "Unpaid",
    },
  ];

  // ================= PAYMENTS =================
  const payments = [
    {
      id: 1,
      client: "ABC Realty",
      date: "10 Jan 2025",
      amount: 999,
      method: "Stripe",
      transactionId: "pi_3Nabcd123",
    },
    {
      id: 2,
      client: "Prime Homes",
      date: "10 Feb 2025",
      amount: 99,
      method: "Stripe",
      transactionId: "pi_3Nxyz456",
    },
  ];

  // ================= HELPERS =================
  const statusTemplate = status => (
    <Tag
      value={status}
      severity={
        status === "Paid" || status === "Active"
          ? "success"
          : status === "Unpaid"
          ? "danger"
          : "warning"
      }
    />
  );

  // ================= UI =================
  return (
    <div className="page-content">
      <Container fluid>

        <Breadcrumbs
          title={props.t("Admin")}
          breadcrumbItem={props.t("Billing")}
        />

        {/* ================= HEADER ================= */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="mb-0"></h4>
          <Button color="primary">Export Report</Button>
        </div>

        {/* ================= OVERVIEW CARDS ================= */}
        <Row className="mb-4">
          <Col xl="3">
            <Card>
              <CardBody>
                <p className="text-muted mb-1">Total Revenue</p>
                <h4>${overview.totalRevenue}</h4>
              </CardBody>
            </Card>
          </Col>

          <Col xl="3">
            <Card>
              <CardBody>
                <p className="text-muted mb-1">Active Subscriptions</p>
                <h4>{overview.activeSubscriptions}</h4>
              </CardBody>
            </Card>
          </Col>

          <Col xl="3">
            <Card>
              <CardBody>
                <p className="text-muted mb-1">Unpaid Invoices</p>
                <h4>{overview.unpaidInvoices}</h4>
              </CardBody>
            </Card>
          </Col>

          <Col xl="3">
            <Card>
              <CardBody>
                <p className="text-muted mb-1">Total Clients</p>
                <h4>{overview.totalClients}</h4>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* ================= SUBSCRIPTIONS ================= */}
        <Card className="mb-4">
          <CardBody>
            <h5 className="mb-3">Subscriptions</h5>

            <DataTable value={subscriptions} responsiveLayout="scroll">
              <Column field="client" header="Client" />
              <Column field="plan" header="Plan" />
              <Column
                field="amount"
                header="Amount"
                body={row => `$${row.amount}`}
              />
              <Column field="startDate" header="Start Date" />
              <Column field="endDate" header="End Date" />
              <Column
                field="status"
                header="Status"
                body={row => statusTemplate(row.status)}
              />
            </DataTable>
          </CardBody>
        </Card>

        {/* ================= INVOICES ================= */}
        <Card className="mb-4">
          <CardBody>
            <h5 className="mb-3">Invoices</h5>

            <DataTable value={invoices} responsiveLayout="scroll">
              <Column field="invoiceNo" header="Invoice #" />
              <Column field="client" header="Client" />
              <Column field="date" header="Date" />
              <Column
                field="amount"
                header="Amount"
                body={row => `$${row.amount}`}
              />
              <Column
                field="status"
                header="Status"
                body={row => statusTemplate(row.status)}
              />
             <Column
  header="Action"
  body={row => (
    <Link
      to={`/invoice-detail`}
      className="btn btn-link btn-sm p-0"
    >
      View
    </Link>
  )}
/>
            </DataTable>
          </CardBody>
        </Card>

        {/* ================= PAYMENTS ================= */}
        <Card>
          <CardBody>
            <h5 className="mb-3">Payments</h5>

            <DataTable value={payments} responsiveLayout="scroll">
              <Column field="client" header="Client" />
              <Column field="date" header="Date" />
              <Column
                field="amount"
                header="Amount"
                body={row => `$${row.amount}`}
              />
              <Column field="method" header="Method" />
              <Column
                field="transactionId"
                header="Transaction ID"
              />
            </DataTable>
          </CardBody>
        </Card>

      </Container>
    </div>
  );
};

AdminBilling.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(AdminBilling);
